// extracted by mini-css-extract-plugin
module.exports = {"loadMore":"IVNry","loader":"V6ySO","spin":"W8iRY","heading":"hxoi5"};